import React from "react";
import {
  ExistingMembershipPlanCard,
  ClickToCancelModal
} from "../../../UI-Component-Library";
import axios from "../../../custom-axios";
import { ApiConstants } from "../../../utils/api-constants";
import { AppUtils } from "../../../utils/app-utils";
import { connect } from "react-redux";
import { DataLayerUtils } from "../../../utils/dataLayer-utils";
import {
  addToShoppingCartItems,
} from "../../../redux/reducers/membership-purchase-reducer";
import { showButtonLoader, hideButtonLoader } from '../../../utils/buttonLoader-util';


class ExistingMembershipComponent extends React.Component {
  constructor() {
    super();
    this.state = {
      subscribedProducts: [],
      combinedMedVetProduct: undefined,
      annualProduct: undefined,
      winbackProduct: undefined,
      pumpkinWellness: undefined,
      petMedRecId: "",
      vetHelpRecId: "",
      showCTCModal: false,
      productId: "",
      recId: "",
      autoRenew: false,
    };
    this.cRef = React.createRef();
  }

  fetchMembershipProductsOfPet() {
    axios
      .processGet(
        `${ApiConstants.URL_GET_MEMBERSHIP_PRODUCTS_OF_PET
        }/${AppUtils.getBusRelAccount()}/${this.props.selectedPetId}`,
        this.cRef
      )
      .then((response) => {
        const data = response.data;
        let combinedMedVetProduct = undefined;
        let annualProduct = undefined;
        let winbackProduct = undefined;
        let petMedRecId = "";
        let vetHelpRecId = ""
        let pumpkinWellness = undefined;
        const subscribedProducts = [];
        data.productList.forEach((product) => {
          let isSubscriptionProduct = 0;
          let isLPMBundleProduct = 0;
          let isAnnualProduct = 0;
          let logoText = null;
          let isPWProduct = undefined;
          if (product?.itemId.toLowerCase().includes('pumkinwellness')) {
            isPWProduct = product.isDisplayed;
          }
          if (
            AppUtils.isEqualString(
              AppUtils.getAlreadyPurchasedAnnualProductName(product.itemId),
              'Annual Protection Membership'
            )
          ) {
            isAnnualProduct = product.isDisplayed;
          }
          if (AppUtils.isEqualString(product.itemId, "LPM Bundle Product")) {
            isLPMBundleProduct = product.isDisplayed;
          }
          if (
            AppUtils.isEqualString(product.itemId, "PetMedInfo Fees") ||
            AppUtils.isEqualString(product.itemId, "PetMedAlert_Sub")
          ) {
            isSubscriptionProduct = product.isDisplayed;

            if (AppUtils.isEqualString(product.itemId, "PetMedInfo Fees")) {
              petMedRecId = product?.recId;
            }
          }
          if (
            AppUtils.isEqualString(product.itemId, "WD Annual Membership") ||
            AppUtils.isEqualString(product.itemId, "WhiskerDoc_Service")
          ) {
            isSubscriptionProduct = product.isDisplayed;
            logoText = "vetHelp";

            if (AppUtils.isEqualString(product.itemId, "WD Annual Membership")) {
              vetHelpRecId = product?.recId;
            }
          }
          if (AppUtils.isEqualString(product.itemId, "DirectConnect")) {
            isSubscriptionProduct = product.isDisplayed;
          }
          if (product.isDisplayed && AppUtils.isEqualString(product.itemId, "Petcademy_Subption")) {
            isSubscriptionProduct = product.isDisplayed;
            logoText = "petcademy"
          }

          if (isPWProduct) {
            pumpkinWellness = {
              productName: product.itemUIName,
              price: AppUtils.getConvertedPrice(product.price),
              frequency: product.isSubscribed ? 'Per Month' : 'Per Year',
              date: product.renewDate,
              logo: logoText,
              recId: product.recId,
              itemId: product.itemId,
              expiryDate: product.expiryDate,
              isExpired: product.expiredProduct,
              isCancelled: !!product.isCanceled,
            }
          }

          if (isSubscriptionProduct) {
            subscribedProducts.push({
              productName: product.itemUIName,
              price: AppUtils.getConvertedPrice(product.price),
              frequency: product.isSubscribed ? 'Per Month' : 'Per Year',
              date: product.renewDate,
              logo: logoText,
              expiryDate: product.expiryDate,
              isExpired: product.expiredProduct,
              recId: product.recId,
              itemId: product.itemId,
              isCancelled: !product.autoRenew,
            })
          }

          if (isLPMBundleProduct) {
            combinedMedVetProduct = {
              productName: product.itemUIName,
              price: AppUtils.getConvertedPrice(product.price),
              frequency: 'Per Year',
              date: product.renewDate,
              expiryDate: product.expiryDate,
              isExpired: product.expiredProduct,
              recId: product.recId,
              itemId: product.itemId,
              isCancelled: !product.autoRenew,
            }
          }

          if (isAnnualProduct) {
            annualProduct = {
              productName:  AppUtils.getAlreadyPurchasedAnnualProductName(product.itemId),
              price: AppUtils.getConvertedPrice(product.price),
              frequency: 'Per Year',
              date: product.renewDate,
              expiryDate: product.expiryDate,
              isExpired: product.expiredProduct,
              recId: product.recId,
              itemId: product.itemId,
              isCancelled: !product.autoRenew,
            }
          }
        })

        if (this.props.winbackBundle) {
          winbackProduct = {
            expiryDate:this.props?.winbackBundle?.offerEndDate,
            offerPrice:AppUtils.getConvertedPrice(this.props?.winbackBundle?.itemPrice)
          }
        }

        this.setState({
          subscribedProducts,
          combinedMedVetProduct,
          annualProduct,
          winbackProduct,
          pumpkinWellness,
          petMedRecId,
          vetHelpRecId
        })
      });
  }

  saveAutoRenewInfo(item) {
    const updateButtonEL = document.getElementById("udpate-button-id");
    showButtonLoader(updateButtonEL);
    axios
      .processPost(ApiConstants.URL_SAVE_AUTO_RENEW_POST, null, {
        email: AppUtils.getUserEmail(),
        busRelAccount: AppUtils.getBusRelAccount(),
        animalId: this.props.selectedPetId,
        itemId: item.itemId,
        recId: item.recId,
        autoRenew: item.autoRenew,
      })
      .then((response) => {
        this.setState({
          showCTCModal: false,
          productId: "",
          recId: "",
          autoRenew: false,
        })
      })
      .catch((err) => { })
      .finally(() => {
        hideButtonLoader(updateButtonEL)
        this.fetchMembershipProductsOfPet()
      })
  }

  addWinbackOfferToCart = (e) => {
    const el = document.getElementById("pet-shopping-cart");

    const item = {
      itemId: this.props?.winbackBundle.itemId,
      itemType: this.props?.winbackBundle.itemType,
      productName: AppUtils.getProductNameFromItemId(
        this.props?.winbackBundle.itemId
      ),
      productCost: AppUtils.getConvertedPrice(
        this.props?.winbackBundle.itemPrice
      ),
      bundleList: this.props?.winbackBundle.bundleList,
    };
    DataLayerUtils.addToCartEvent(item);
    this.props.addToShoppingCartItems({
      selectedPetId: this.props.selectedPetId,
      item,
    });

    if(el) {
      el.scrollIntoView({behavior: "smooth"});
    }

    e.preventDefault();
  }

  componentDidMount() {
    this.fetchMembershipProductsOfPet();
  }

  getMembershipProductDetails() {
    if (this.props.memberType === 2 ||
      this.props.memberType === 3
    ) {
      let benefits = [
        "Connect with your pet's finder and arrange a quick, safe reunion using DirectConnect.",
        "Receive a $25 Petco coupon, redeemable for in-store purchases.",
        "Reach veterinary professionals anytime by phone, email or live chat powered by whiskerDocs® (complimentary for 1 year)",
        "With 24PetMedAlert®, critical medical and behavioral information will be shared with the shelter or vet the pet is brought to when found (complimentary for 1 year)",
        "Access to Lost Pet Recovery Specialists who can quickly launch the process of finding your pet",
        "Save on pet-sitting and dog walking services with a $30 Rover coupon.",
      ];

      if (AppUtils.isUsCountry()) {
        benefits.splice(1, 0, "First month FREE in the Pumpkin Wellness Club - You’re automatically enrolled to save up to $380/year on routine vet care, including annual check-ups & vaccines, plus special discounts. After your free month, you will be charged $19.95/month, with the option to cancel anytime in your account dashboard.")
      }

      if (this.props.isLPMPlusProduct) {
        return {
          productName: 'Lifetime Protection Membership Plus',
          productBenefits: [...benefits,
            "Customized metal ID tags with all of your contact information to make reunification easier",
            "Customized training with easy to follow video lessons for you and your pet, powered by Petcademy"
          ]
        }
      }

      return {
        productName: 'Lifetime Protection Membership',
        productBenefits: benefits
      }
    }

    return {};
  }
  getMembershipCard() {
    const membershipPlan = this.getMembershipProductDetails();
    if (this.state.subscribedProducts.length === 0 &&
      Object.keys(membershipPlan).length === 0 &&
      !this.state.annualProduct
    ) {
      return <div></div>
    }

    return (
      <ExistingMembershipPlanCard
        membershipProduct={membershipPlan}
        subscriptionProducts={this.state.subscribedProducts}
        combinedMedVetProduct={this.state.combinedMedVetProduct}
        annualProduct={this.state.annualProduct}
        winbackProduct={this.state.winbackProduct}
        pumpkinWellness={this.state.pumpkinWellness}
        renewButtonProps={{
          id: "winback-renew-button-id",
          onClick: (e) => {
            this.addWinbackOfferToCart(e);
          }
        }}
        autoRenewLinkProps={{
          onClick: (item) => {
            let productId, recId;
            if (AppUtils.isEqualString(item.itemId, "LPM Bundle Product")) {
              productId = "PetMedInfo Fees,WD Annual Membership";
              recId = `${this.state.petMedRecId},${this.state.vetHelpRecId}`;
            } else {
              productId = item.itemId;
              recId = item.recId;
            }
            this.setState({
              showCTCModal: true,
              autoRenew: item.isCancelled,
              productId,
              recId,
            })
          }
        }}
      />
    );

  }
  render() {
    return <>
      <div ref={this.cRef}>
        {this.getMembershipCard()}
      </div>
      <ClickToCancelModal
        open={this.state.showCTCModal}
        modalText={
          this.state.productId.toLowerCase().includes('pumkinwellness')
            ? "Are you sure you want to turn off auto-renewal? Your subscription to Pumpkin Wellness Club will end immediately, and you’ll lose access to your benefits right away. Auto-renewal cannot be turned back on once canceled."
            : "Are you sure you want to turn of auto-renewal? Your subscription will not renew automatically at the end of the current period. You’ll continue to enjoy all the benefits until your subscription expires."
        }
        isCancelled={!this.state.autoRenew}
        onClose={() => {
          this.setState({
            showCTCModal: false,
          })
        }}
        closeButtonProps={{
          onClick: () => {
            this.setState({
              showCTCModal: false,
            })
          }
        }}
        updateAutoRenewal={{
          id: "udpate-button-id",
          onClick: () => {
            this.saveAutoRenewInfo({
              itemId: this.state.productId,
              recId: this.state.recId,
              autoRenew: this.state.autoRenew,
            });
          }
        }}
      />
    </>
  }
}
const mapStateToProps = (state) => {
  const customerProfileStore = state.customerProfileStore;
  return {
    selectedPetId: customerProfileStore.selectedPetId,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    addToShoppingCartItems: (item) => dispatch(addToShoppingCartItems(item)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExistingMembershipComponent);
